import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {ContentSetOverviewResultVo} from '../../common/shared/api/nicolas/vo/ContentSetOverviewResultVo.interface';

/**
 * 콘텐츠 세트 개요 조회
 *
 * Origin: pageNicolasApi.getContentSetOverview
 * API: GET /api/v1/content/set_overview
 */
export async function getContentSetOverview(
  {
    setId,
  }: {
    setId: string;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & {result: ContentSetOverviewResultVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/content/set_overview',
    {
      method: 'GET',
      params: {
        set_id: setId,
      },
    },
    options
  );
  return response.data;
}
